import module from 'nominas/sumario/module.js'
import template from './template.html'
import * as moment from 'moment'
import './style.scss'

const catalogoEstatus = [
  {id: '', descripcion: 'Todos'},
  {id: 'A', descripcion: 'Abierta'},
  {id: 'P', descripcion: 'Pendiente'},
  {id: 'C', descripcion: 'Cerrada'},
]

export class NominasSumarioListaItemComponent {
  data
  mostrarEtiquetas = false
  expandirImporte = false
  permisos
  catalogo = {
    estatus: catalogoEstatus,
  }

  constructor ($state) {
    this.$state = $state
  }

  $onInit () {
    this.fechaPago = moment(this.data.fecha_pago).format('[Fecha de pago] D [de] MMMM [de] YYYY')
  }

  duplicar () {
    this.$state.go('nominas.agregar', {proyecto_id: this.data.id_empresa, nomina_id: this.data.id_nomina})
  }

  /*descargar () {
    this.NominaDocumentosComprobantedeposito.get(this.data.id_empresa, this.data.id_nomina)
  }*/
}

module.component('nominasSumarioListaItem', {
  controller: NominasSumarioListaItemComponent,
  template,
  bindings: {
    data: '<',
    mostrarEtiquetas: '<',
    expandirImporte: '<',
    permisos: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/lista/item/component.js